import styled from 'styled-components';
import { useSelector } from 'src/store/store';
import Card from 'src/components/card';
import { Disclaimer } from 'src/components/sidebar/disclaimer';
import PinnedPosts from 'src/modules/community/shared/components/sidebar/pinnedPosts';
import TopicList from 'src/modules/community/shared/components/sidebar/topicList';
import CommunityPostsArchive from 'src/modules/community/communityPosts/components/sidebar/communityPostsArchive';
import GlobalSearch from 'src/modules/search/shared/components/searchBar';
import LatestPoll from 'src/modules/community/shared/components/sidebar/communityLatestPoll';
import i18n from 'src/utils/translate';
export default function CommunityPostsSidebar(): JSX.Element {
  const communityName = useSelector(({
    context
  }) => context.currentCommunity?.name);
  const topics = useSelector(({
    context
  }) => context.currentCommunity?.topics);
  const pinnedPosts = useSelector(({
    pages
  }) => pages.communityPosts.pinnedPosts);
  const latestPoll = useSelector(({
    pages
  }) => pages.communityPosts.latestPoll);
  return <div className="community-sidebar" data-testid="community-sidebar" data-sentry-component="CommunityPostsSidebar" data-sentry-source-file="communityPostsSidebar.tsx">
      <Card title={i18n.t('Search posts')} data-sentry-element="Card" data-sentry-source-file="communityPostsSidebar.tsx">
        <StyledSearchBar dataTestId="search-page-bar" isCommunitySearch={true} placeholder={i18n.t('Search posts on ') + communityName} data-sentry-element="StyledSearchBar" data-sentry-source-file="communityPostsSidebar.tsx" />
      </Card>

      <PinnedPosts posts={pinnedPosts} data-sentry-element="PinnedPosts" data-sentry-source-file="communityPostsSidebar.tsx" />

      {latestPoll && <LatestPoll widget={latestPoll} />}

      {topics && <TopicList topics={topics} />}

      <Card data-sentry-element="Card" data-sentry-source-file="communityPostsSidebar.tsx">
        <Disclaimer data-sentry-element="Disclaimer" data-sentry-source-file="communityPostsSidebar.tsx" />
      </Card>

      <CommunityPostsArchive data-sentry-element="CommunityPostsArchive" data-sentry-source-file="communityPostsSidebar.tsx" />
    </div>;
}
const StyledSearchBar = styled(GlobalSearch)`
  margin-top: 20px;
`;